import { render, staticRenderFns } from "./BasicProductOption.vue?vue&type=template&id=a9006f18&scoped=true"
import script from "./BasicProductOption.vue?vue&type=script&lang=js"
export * from "./BasicProductOption.vue?vue&type=script&lang=js"
import style0 from "./BasicProductOption.vue?vue&type=style&index=0&id=a9006f18&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9006f18",
  null
  
)

export default component.exports